import React from 'react';
import {useTranslation} from 'react-i18next';

const Contacts = () => {
    const {t} = useTranslation();

    return (
        <div className="contacts">
            <div className="contacts-items">
                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>
                            <a href={`mailto:${t('contacts_page.contact.email')}`}>{t('contacts_page.contact.email')}</a>
                        </p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>{t('contacts_page.contact.email_label')}</h6>
                    </div>
                </div>

                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>{t('contacts_page.contact.phone')}</p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>{t('contacts_page.contact.phone_label')}</h6>
                    </div>
                </div>

                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>{t('contacts_page.contact.fax')}</p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>{t('contacts_page.contact.fax_label')}</h6>
                    </div>
                </div>

                <div className="contacts-item">
                    <div className="contacts-item-description">
                        <p>
                            <a href={t('contacts_page.contact.instagram')} target="_blank"
                               rel="noopener noreferrer">{t('contacts_page.contact.instagram')}</a>
                        </p>
                    </div>

                    <div className="contacts-item-title">
                        <h6>{t('contacts_page.contact.instagram_label')}</h6>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contacts;
